import { render } from "./BookContent.vue?vue&type=template&id=b3fbdd7c&scoped=true"
import script from "./BookContent.vue?vue&type=script&lang=js"
export * from "./BookContent.vue?vue&type=script&lang=js"

import "./BookContent.vue?vue&type=style&index=0&id=b3fbdd7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3fbdd7c"]])

export default __exports__